<template>
  <v-container class="mb-7" fluid>
    <v-row>
      <OverallPerformance :external-user="true" :external-user-id="this.$store.state.shared.id"
                          :external-user-name="this.$store.state.shared.firstName"
                          :riskRewardRatio="riskRewardRatio" :trades="this.$store.state.book.trades"
                          :winningRatio="winningRatio"/>
    </v-row>

    <v-divider class="my-3 mr-3"/>

    <v-row>
      <TradeList :shared="true"/>
    </v-row>
  </v-container>
</template>

<script>
import TradeList from "../../Journal/TradeList";
import OverallPerformance from "../../Journal/OverallPerformance";

export default {
  name: "SharedJournalHome",
  components: {OverallPerformance, TradeList},
  data() {
    return {
      winningRatio: 0,
      riskRewardRatio: 0,
    };
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
